module.exports = __webpack_public_path__ + "static/img/zeta_cr_template_04.497fa7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zeta_cr_template_04.png
// module id = kiGH
// module chunks = 1